module.exports = __webpack_public_path__ + "media/tags/smartsearch/orange-plus-93088f20f26d32239e30c25212ff226e.png";